import { useState, useEffect } from 'react';

/**
 * Este hook cambia la cantidad de libros que se deben ver segun los breskpoints o resoluciones de pantalla 
 @returns {number} cantidad de libros
*/
export const useBooksPerPage = () => {
  const [numberBooks, setNumberBooks] = useState(20);

  useEffect(()=>{
    const setMobile = () => {
      let validacion = 0;
      
      if(window.innerWidth > 509 && window.innerWidth <= 577){
        validacion = 21;
      }else if (window.innerWidth >= 578 && window.innerWidth <= 1271){
        validacion = 20;
      }else if (window.innerWidth >= 1272 && window.innerWidth <= 1399){
        validacion = 24;
      }else if (window.innerWidth >= 1400 && window.innerWidth <= 2199){
        validacion = 21;
      }else if (window.innerWidth >= 2200){
        validacion = 24;
      }else{
        validacion = 20;
      }
      setNumberBooks(validacion)
    }
    setMobile();
    window.addEventListener('resize', setMobile)
    return () => {
      window.removeEventListener('resize', setMobile)
    }
  }, [])

  return numberBooks;
}
